(function () {
  function getProductFromShopifyMeta() {
    try {
      const p = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
      if (p && p.variants && p.variants.length) {
        // Normalizziamo: vogliamo {variants:[{available, options:[] }], options:[...]}
        const first = p.variants[0];
        const optionCount = first.options ? first.options.length : 0;
        return {
          options: Array.from({ length: optionCount }, (_, i) => `Option ${i + 1}`),
          variants: p.variants.map(v => ({
            available: !!v.available,
            options: v.options
          }))
        };
      }
    } catch (e) {}
    return null;
  }

  function getProductFromJSONScript() {
    // Cerca QUALUNQUE script json che contenga "variants"
    const candidates = document.querySelectorAll('script[type="application/json"]');
    for (const el of candidates) {
      const txt = (el.textContent || '').trim();
      if (!txt || txt.length < 50) continue;
      if (!txt.includes('"variants"')) continue;
      try {
        const data = JSON.parse(txt);
        const product = data.product && data.product.variants ? data.product : data;
        if (product && product.variants && product.variants.length) return product;
      } catch (e) {}
    }
    return null;
  }

  function getProductData() {
    return getProductFromShopifyMeta() || getProductFromJSONScript();
  }

  function getOptionGroups() {
    // Dawn: i gruppi sono spesso fieldset.product-form__input con data-option-position
    const groups = document.querySelectorAll('.product-form__input[data-option-position]');
    if (groups.length) return Array.from(groups);

    // fallback: gruppi con radio dentro
    const fallback = Array.from(document.querySelectorAll('.product-form__input')).filter(g =>
      g.querySelector('input[type="radio"]')
    );
    return fallback;
  }

  function getSelectedOptions(optionCount) {
    const selected = Array(optionCount).fill(null);

    // Dawn (data-option-position parte da 1)
    const groups = getOptionGroups();
    groups.forEach((group, idx) => {
      const pos = group.dataset.optionPosition ? (parseInt(group.dataset.optionPosition, 10) - 1) : idx;
      const checked = group.querySelector('input[type="radio"]:checked');
      if (checked) selected[pos] = checked.value;
    });

    // fallback select
    const selects = document.querySelectorAll('select[name^="options"], select[data-option]');
    if (selects.length) {
      selects.forEach((sel, i) => {
        if (i < selected.length) selected[i] = sel.value || null;
      });
    }

    return selected;
  }

  function computePossibleValues(product, selected) {
    const optionCount = selected.length;
    const possible = Array.from({ length: optionCount }, () => new Set());

    product.variants.forEach(v => {
      if (!v.available) return;

      for (let i = 0; i < optionCount; i++) {
        let ok = true;
        for (let j = 0; j < optionCount; j++) {
          if (j === i) continue;
          if (selected[j] && v.options[j] !== selected[j]) {
            ok = false;
            break;
          }
        }
        if (ok) possible[i].add(v.options[i]);
      }
    });

    return possible;
  }

  function hideUnavailable() {
    const product = getProductData();
    if (!product || !product.variants || !product.variants.length) return;

    const optionCount = (product.options && product.options.length) || (product.variants[0].options ? product.variants[0].options.length : 0);
    if (!optionCount) return;

    const selected = getSelectedOptions(optionCount);
    const possible = computePossibleValues(product, selected);

    // RADIO (bottoni)
    const groups = getOptionGroups();
    if (groups.length) {
      groups.forEach((group, idx) => {
        const pos = group.dataset.optionPosition ? (parseInt(group.dataset.optionPosition, 10) - 1) : idx;
        const radios = group.querySelectorAll('input[type="radio"]');

        radios.forEach(radio => {
          const value = radio.value;
          const shouldShow = possible[pos] && possible[pos].has(value);

          const label = group.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
          const wrapper = (label && label.closest('li, .swatch, .pill, .variant-option, .product-form__input, div')) || label;

          if (!wrapper) return;

          if (!shouldShow) {
            wrapper.style.display = 'none';
            wrapper.setAttribute('data-hidden-unavailable', 'true');
            if (radio.checked) radio.checked = false;
          } else {
            if (wrapper.getAttribute('data-hidden-unavailable') === 'true') {
              wrapper.style.display = '';
              wrapper.removeAttribute('data-hidden-unavailable');
            }
          }
        });
      });
    }

    // SELECT (se presenti)
    const selects = document.querySelectorAll('select[name^="options"], select[data-option]');
    selects.forEach((sel, i) => {
      Array.from(sel.options).forEach(opt => {
        const shouldShow = possible[i] && possible[i].has(opt.value);
        opt.hidden = !shouldShow;
      });
    });
  }

  function init() {
    // primo run
    hideUnavailable();

    // ogni cambio
    document.addEventListener('change', (e) => {
      if (e.target.matches('input[type="radio"], select[name^="options"], select[data-option]')) {
        hideUnavailable();
      }
    });

    // eventi Dawn
    document.addEventListener('variant:change', hideUnavailable);

    // evento Globo (quando re-renderizza)
    document.addEventListener('gpoRenderCompleted', () => {
      setTimeout(hideUnavailable, 0);
    });

    // sicurezza: alcuni temi re-renderizzano con micro-delay
    setTimeout(hideUnavailable, 300);
    setTimeout(hideUnavailable, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();